// extracted by mini-css-extract-plugin
export var form = "subscribe-second-module--form--d82ed";
export var spin = "subscribe-second-module--spin--8b07e";